import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { database } from "../../appWrite";
import { Models } from "appwrite";

interface Testimonial extends Models.Document {
  name: string;
  heading: string;
  review: string;
  image: string;
}

interface TestimonialState {
  testimonials: Testimonial[];
  loading: boolean;
  error: string | null;
}

const initialState: TestimonialState = {
  testimonials: [],
  loading: false,
  error: null,
};

// Fetch Testimonials
export const fetchTestimonials = createAsyncThunk(
  "testimonials/fetch",
  async () => {
    const response = await database.listDocuments<Testimonial>(
      "67ce8a4a0032e13c6368",
      "67d7eb5a0013791e9da4"
    );
    return response.documents;
  }
);

const testimonialSlice = createSlice({
  name: "testimonials",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTestimonials.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchTestimonials.fulfilled, (state, action) => {
        state.loading = false;
        state.testimonials = action.payload;
      })
      .addCase(fetchTestimonials.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Something went wrong";
      });
  },
});

export default testimonialSlice.reducer;
